var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('locale-field',_vm._b({attrs:{"outlined":"","hide-details":"auto"},model:{value:(_vm.iso),callback:function ($$v) {_vm.iso=$$v},expression:"iso"}},'locale-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }